import React from 'react';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import RichTextField from 'Components/ComponentLibrary/Molecules/RichTextField';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import SendIcon from '@material-ui/icons/Send';
import { getLightBorder } from 'Components/utils';
import { useCommentLayoutContext } from '../../../../../../CommentLayoutProvider';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(1),
    ...getLightBorder(theme, { top: true }),
  },
  sendButton: {},
}), { name: 'Footer' });

const Footer = () => {
  const { handleSendMessage, sendingMessage } = useCommentLayoutContext();
  const classes = useStyles();
  const [text, setText] = React.useState('');

  return (
    <Box
      className={classes.root}
    >
      <form
        className={classes.form}
        onSubmit={() => {
          return handleSendMessage();
        }}
      >
        <RichTextField
          inputMinHeight={40}
          value={text}
          onChange={(value) => {
            setText(value);
          }}
          inlineToolbar={
            <IconButton
              className={classes.sendButton}
              disabled={sendingMessage}
              onClick={() => {
                return handleSendMessage(text, setText);
              }}
              variant={'contained'}
              color={'primary'}
              title={'Send Message'}
              icon={SendIcon}
            />
        }
        />
      </form>
    </Box>
  );
};

export default Footer;
